export default __webpack_public_path__ + "static/media/SolderingImg.e8791617.jpg";